import { ThemeConfig, theme } from "antd";

export { GlobalStyle } from "./theme";

const blue = "#0779db";
const red = "#e30039";
const orange = "#F46C10";
const green = "#32B546";
const yellow = "#FFD007";
const purple = "#504DC1";

const brandPrimary = purple;

const baseThemeConfig: ThemeConfig = {
    hashed: false,
    cssVar: {
        key: "sol",
    },
    token: {
        blue,
        red,
        orange,
        green,
        yellow,
        purple,

        colorPrimary: brandPrimary,
        colorInfo: brandPrimary,
        colorSuccess: green,
        colorError: red,
        colorWarning: orange,

        borderRadiusXS: 2,
        borderRadiusSM: 4,
        borderRadius: 8,
        borderRadiusLG: 14,

        /* FONT SIZE */
        fontFamily: "'Nunito Sans', 'sans-serif'",

        fontSize: 14,
        fontSizeHeading1: 24,
        fontSizeHeading2: 20,
        fontSizeHeading3: 18,
        fontSizeHeading4: 16,
        fontSizeHeading5: 14,

        fontWeightStrong: 700,
        screenXS: 320,
        screenXSMin: 320,
    },
};

export const baseThemeToken = theme.getDesignToken(baseThemeConfig);

export const themeConfig: ThemeConfig = {
    ...baseThemeConfig,
    components: {
        ...baseThemeConfig.components,
        Menu: {
            ...baseThemeConfig.components?.Menu,
            itemMarginInline: baseThemeToken.marginXS,
            itemMarginBlock: baseThemeToken.marginXS,
            itemHeight: 32,
            iconMarginInlineEnd: baseThemeToken.paddingXS,
            iconSize: 24,
        },
        Layout: {
            headerBg: "var(--ant-layout-header-bg)",
            footerBg: "var(--ant-color-bg-container)",
        },
        Button: {
            controlHeightLG: 48,
        },
        Input: {
            controlHeightLG: 48,
        },
        Select: {
            singleItemHeightLG: 48,
        },
        Segmented: {
            trackPadding: baseThemeToken.paddingXXS,
        },
        Tag: {
            // Give rounded-full border radius
            borderRadiusSM: 999,
        },
        Descriptions: {
            labelColor: baseThemeToken.colorTextSecondary,
            fontSizeLG: baseThemeToken.fontSizeHeading3,
            titleMarginBottom: baseThemeToken.margin,
        },
        Dropdown: {
            borderRadiusLG: baseThemeToken.borderRadius,
            borderRadius: baseThemeToken.borderRadiusSM,
        },
    },
};
